import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";export const styles = (theme: Theme) => {
	return ({
		tooltip: {
			fontSize: "1em",
		},
		tooltipIcon: {
			marginLeft: 8
		},
		disabledSwitch: {
			visibility: "hidden",
		},
		switchLabel: {
			display: "flex",
			alignItems: "center"
		},
		errorMessage: {
			color: theme.palette.error.main,
			fontWeight: "bold",
		},
	} satisfies Record<string, CSSObject>)
}